import axios from "axios";

export default {
  methods: {
    fetchNotif() {
      axios
        .get("/v1/dashboard/notification", {
          headers: {
            "X-Token": this.userToken,
          },
        })
        .then((response) => {
          this.listNotif = response.data.notification;
          this.totalNotif = response.data.total_notification;
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
  },
};
